/*eslint-disable */
import { bus } from '../../main';
import toast from '../../services/toast';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'searchresult',
  components: {},
  props: [],
  data() {
    return {
      loader:false,
      filterResult: {},
      filterResultfun:'',
      courses:''
    }
  },
  computed: {
    ...mapGetters([
      'filterResultDetials',
    ]),
    getSearchDataByName() {
        this.loader = true;
        this.$store.dispatch('filterField', { name: this.$route.params.searchkeyword }).then((response) => {
          if (response.data.code == '2000') {
            this.loader = false;
            return this.courses = this.$store.getters.filterResultDetials
          }
        })
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.filterResultfun = this.courses.results
      }
    }
  },
  mounted() {
    this.getSearchDataByName
    this.SetIntialStatus
    if(this.$route.params.searchkeyword){
     bus.$emit('ShowSearchKeyWord', this.$route.params.searchkeyword);
    }
  },
  methods: {
    enrollcourse(id) {
      let data = { course: id }
      this.$store.dispatch('setEnrollNewCourse', data)
        .then((res) => {
          if (res.data.code == '3017') {
            toast.success(res.data.msg);
            this.$store.dispatch('getcourselist').then((res) => {
              this.$store.dispatch('filterField', { name: this.$route.params.searchkeyword }).then((res) => {
              })
            }).catch((err) => {
            });
          }
        })
        .catch((err) => {
        })
    },
  },
  beforeMount() {
    this.getSearchDataByName
  },
  watch: {
    getSearchDataByName() {
      return this.$store.getters.filterResultDetials
    },
    SetIntialStatus() {
      if (this.courses != undefined) {
        this.filterResultfun = this.courses.results
      }
    }
  },
  beforeRouteLeave: function(to, from, next) {
    bus.$emit('ShowSearchKeyWord', '');
    next();
  }
}
